import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from '@material-ui/core/Badge';
import { LaunchTwoTone as LaunchIcon } from '@material-ui/icons';
import PropTypes from "prop-types";
import VerticalTabsStyle from "../styles/verticalTabsStyle";
import ScheduledVisits from "./scheduledVisits/VisitsUI/v2";
import PendingFiles from "./pendingFiles/VisitsUI/v2";
import SearchOrders from "./searchOrders/SearchForm/v1";
import commentIcon from "../assets/comment.svg";
import disabledCommentIcon from "../assets/disabledComment.svg";
import dashboardIcon from "../assets/dashboard.svg";
import disabledDashboardIcon from "../assets/disabledDashboard.svg";
import folderIcon from "../assets/folder.svg";
import searchIcon from "../assets/magnify.svg";
import disabledFolderIcon from "../assets/disabledFolder.svg";
import calenderIcon from "../assets/calender.svg";
import disabledSearchIcon from "../assets/disabledMagnify.svg";
import disabledCalenderIcon from "../assets/disabledCalender.svg";
import CommentView from "./commentView";
import useQueryParams from "../hooks/useQueryParams";
import useVisitsActions from "../hooks/useVisitsActions";
import { get as versionSelector } from '../utils/versionSelector';
import { FEATURE } from '../utils/feature';
import { Name as NameMap } from '../constants/name.constant';
import { DefaultVersion as version } from '../constants/visits.constant';

const NameGetter = versionSelector.bind(this, NameMap);
const TabOpenWidth = 320;

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}
// 100 and 200 value are used for clicking on slider value direcly to exit the card page -akshay
function TabPanel(props) {
  const { children, value, index, className, tabPannelClassName, ...other } =
    props;
  return value === index ||
    (value === 100 && index === 0) ||
    (value === 200 && index === 1) ||
    (value === 400 && index === 4) ? (
    <Typography
      component="div"
      role="tabpanel"
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className={tabPannelClassName}
      {...other}
    >
      {(value === index ||
        (value === 100 && index === 0) ||
        (value === 200 && index === 1) ||
        (value === 400 && index === 4)) && (
        <div className={className}>{children}</div>
      )}
    </Typography>
  ) : null;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const StyledBadge = withStyles(() => ({
  badge: {
    color: '#ffffff',
    background: '#334A3C'
  },
}))(Badge);

const hasFeature = FEATURE();

const VerticalTabs = (props) => {
  const {
    classes,
    callStarted,
    selectedPrescriberInfo: { SurveyLink } = {},
    scheduledVisits: _scheduledVisits = {},
    asyncOrders = {},
    history,
    GetScheduleVisitsCards: getScheduledVisitsV1 = () => {},
    GetScheduleVisitsLV: getScheduledVisitsV2 = () => {},
    GetPendingFilesCards: getPendingVisitsV1 = () => {},
    GetPendingFilesLV: getPendingVisitsV2 = () => {},
  } = props;
  let restProps = { ...props };
  delete restProps.classes;
  const [value, setValue] = React.useState(0);
  const [tabWidth, setWidth] = React.useState(92);
  const [isHovering, setHover] = React.useState();
  const [searchDataFields, setSearchDataFields] = React.useState({
    orderId: "",
    startDate: "",
    endDate: "",
    firstName: "",
    lastName: "",
  });
  const [cardData, setCardData] = React.useState(void 0);

  /**
   * @description useQueryParams is used to read the version from query parameter
   */
  const { json: { version: queryVersion = 1 } } = useQueryParams(restProps);
  const { getScheduledVisits, getPendingVisits } = useVisitsActions({
    version,
    actions: [
      {
        getScheduledVisits: getScheduledVisitsV1,
        getPendingVisits: getPendingVisitsV1
      },
      {
        getScheduledVisits: getScheduledVisitsV2,
        getPendingVisits: getPendingVisitsV2
      }
    ]
  });
  const Name = NameGetter(version);
  const { visits: scheduledVisits = {} } = _scheduledVisits;
  const { visits: pendingVisits = {} } = asyncOrders;

  useEffect(() => {
    if (!localStorage.getItem('userId')) {
      return false;
    }

    if (!pendingVisits.loading && !pendingVisits.called) {
      getPendingVisits();
    }
  }, []);

  const handleChange = async (event, newValue, data) => {
    if (newValue === 0 && (value === newValue || value === 100)) {
      getScheduledVisits();
    }
    if (newValue === 1 && (value === newValue || value === 200)) {
      getPendingVisits();
    }

    if (props.callStarted) {
      return;
    }

    if (
      ![2, 3].includes(queryVersion) &&
      ['scheduleCards', 'pendingFilesCard', 'searchOrders'].includes(newValue)
    ) {
      const {
        GetPatientInfo,
        ResetPatientInfo,
        GetNotes,
        GetProductInfo = () => {},
        GetConsultQuestions,
        GetProductList = () => {}
      } = props;
      ResetPatientInfo && ResetPatientInfo();
      GetNotes && GetNotes(data);
      GetPatientInfo && GetPatientInfo(data);
      GetConsultQuestions && GetConsultQuestions(data);
      GetProductInfo(data).then(({ data: { Data } }) => {
        const { orderId, product } = Data;
        if (product.ProductId) {
          GetProductList({ ProductId: product.ProductId, OrderId: orderId });
        }
      });
    }

    if (newValue === "searchOrders") {
      newValue = 400;
    }

    if (newValue === 4) {
      let { ClearSearchData } = props;
      ClearSearchData && ClearSearchData();
      setSearchDataFields({
        orderId: "",
        startDate: "",
        endDate: "",
        firstName: "",
        lastName: "",
      });
    }

    if (newValue === "pendingFilesCard") {
      newValue = 200;
    }
    if (newValue === "scheduleCards") {
      newValue = 100;
    }
    setValue(newValue);
    if (data) {
      setCardData(data);
    } else {
      setCardData(void 0);
    }

    if (hasFeature.PATIENT_CHART_V2 && queryVersion === 2 && data && data.OrderId && data.UserId) {
      history.push(`/patientchart/${data.OrderId}/${data.UserId}`);
    }

    if (hasFeature.PATIENT_CHART_V3 && queryVersion === 3 && data && data.OrderId && data.UserId) {
      history.push(`/patientchart-v3/${data.OrderId}/${data.UserId}`);
    }
  };

  const onHoverOutSide = (e) => {
    if (props.callStarted) {
      return;
    }
    if (e.target && e.target.closest) {
      const closest = e.target.closest(`[data-tabs = "vertical-tab"]`);
      if (!closest) {
        window.removeEventListener("mousemove", onHoverOutSide);
        setWidth(92);
        setHover(void 0);
      }
    }
  };

  const onHoverTab = (e) => {
    if (props.callStarted) {
      return;
    }
    if (tabWidth !== TabOpenWidth) {
      window.addEventListener("mousemove", onHoverOutSide);
      setWidth(TabOpenWidth);
    }
  };

  const onHoverTabOut = (e) => {
    if (props.callStarted) {
      return;
    }
    if (tabWidth !== 92) {
      window.removeEventListener("mousemove", onHoverOutSide);
      setWidth(92);
      setHover(void 0);
    }
  };

  const VersionSelectorCollection = new Map([
    ['true', (
      <Tab
        component={() => (
          <div
            className='flex flex-column flex-fill justify-content-flex-end'
            onClick={() => {
              history.push(`/scheduled-visits`);
            }}
            onMouseEnter={() => {
              !callStarted && isHovering !== 5 && setHover(5);
            }}
            onMouseOver={() => {
              !callStarted && isHovering !== 5 && setHover(5);
            }}
            onMouseLeave={() => {
              !callStarted && isHovering !== undefined && setHover(undefined);
            }}
          >
            <div className='flex align-items-center justify-content-flex-start pointer color-white min-width-92 min-height-110'>
              <div className='absolute flex align-items-center justify-content-flex-start'>
                <div className='flex align-items-center justify-content-center min-width-92 min-height-110 max-height-110'>
                  <LaunchIcon fontSize='large' className='color-white' />
                </div>

                <div className='flex align-items-center justify-content-center font-22'>{Name.JUMP_TO_V2}</div>
              </div>
            </div>
          </div>
        )}
        {...a11yProps(5)}
      />
    )],
    ['false', <></>],
  ]);

  const TabChildren = (
    <Tabs
      data-tabs="vertical-tab"
      orientation="vertical"
      variant="scrollable"
      value={value}
      onMouseEnter={onHoverTab}
      onMouseOver={onHoverTab}
      onMouseLeave={onHoverTabOut}
      onChange={handleChange}
      scrollButtons={"off"}
      aria-label="Vertical tabs example"
      style={{
        width: tabWidth,
        minWidth: tabWidth,
        maxWidth: tabWidth,
        zIndex: 2,
      }}
      classes={{
        root: classes.tabs,
        centered: classes.centered,
        flexContainerVertical: classes.flexContainerVertical,
        indicator: classes.tabIndicatorStyle,
      }}
    >
      <Tab
        component={(props) => (
          <div
            id="schedule-visit-tab"
            onClick={(e) => {
              !callStarted && handleChange(e, 0);
            }}
            onMouseEnter={(e) => {
              !callStarted && isHovering !== 0 && setHover(0);
            }}
            onMouseOver={(e) => {
              !callStarted && isHovering !== 0 && setHover(0);
            }}
            onMouseLeave={(e) => {
              !callStarted && isHovering !== void 0 && setHover(void 0);
            }}
            className={`${classes.tabContainer} ${classes.tabFirstContainer} ${
              value === 0 || isHovering === 0 || value === 100
                ? classes.tabContainerSelected
                : ""
            } ${callStarted ? classes.disabledCursor : ""}`}
          >
            <div className={classes.iconWrapper}>
              <StyledBadge overlap='circular' badgeContent={scheduledVisits.data.length} max={99} color="primary">
                <img
                  className={`${classes.calenderIcon}`}
                  src={callStarted ? disabledCalenderIcon : calenderIcon}
                  alt=""
                />
              </StyledBadge>
            </div>
            <div className={classes.sideBarTextPrimary}>{Name.SCHEDULED_VISITS_HEADER}</div>
          </div>
        )}
        {...a11yProps(0)}
      />
      <Tab
        component={(props) => (
          <div
            id="pending-files-tab"
            onClick={(e) => {
              !callStarted && handleChange(e, 1);
            }}
            onMouseEnter={(e) => {
              !callStarted && isHovering !== 1 && setHover(1);
            }}
            onMouseOver={(e) => {
              !callStarted && isHovering !== 1 && setHover(1);
            }}
            onMouseLeave={(e) => {
              !callStarted && isHovering !== void 0 && setHover(void 0);
            }}
            className={`${classes.tabContainer} ${
              value === 1 || isHovering === 1 || value === 200
                ? classes.tabContainerSelected
                : ""
            } ${callStarted ? classes.disabledCursor : ""}`}
          >
            <div className={classes.iconWrapper}>
              <StyledBadge overlap='circular' badgeContent={pendingVisits.data.length} max={99} color="primary">
                <img
                  className={`${classes.folderIcon}`}
                  src={callStarted ? disabledFolderIcon : folderIcon}
                  alt=""
                />
              </StyledBadge>
            </div>
            <div className={classes.sideBarTextPrimary}>{Name.PENDING_FILES_HEADER}</div>
          </div>
        )}
        {...a11yProps(1)}
      />
      <Tab
        component={(_props) => (
          <div
            id="prescriber-portal-tab"
            onClick={() => {
              !callStarted && setHover(void 0);
              !callStarted && setWidth(92);
              !callStarted && props.ToggleModal(true);
            }}
            onMouseEnter={(e) => {
              !callStarted && isHovering !== 2 && setHover(2);
            }}
            onMouseOver={(e) => {
              !callStarted && isHovering !== 2 && setHover(2);
            }}
            onMouseLeave={(e) => {
              !callStarted && isHovering !== void 0 && setHover(void 0);
            }}
            className={`${classes.tabContainer} ${
              value === 2 || isHovering === 2
                ? classes.tabContainerSelected
                : ""
            } ${callStarted ? classes.disabledCursor : ""}`}
          >
            <img
              className={`${classes.dashboardIcon}`}
              src={callStarted ? disabledDashboardIcon : dashboardIcon}
              alt=""
            />
            <div className={classes.sideBarTextPrimary}>{Name.PRESCRIBER_PORTAL_HEADER}</div>
          </div>
        )}
        {...a11yProps(2)}
      />

      <Tab
        component={(props) => (
          <div
            id="search-orders-tab"
            onClick={(e) => {
              !callStarted && handleChange(e, 4);
            }}
            onMouseEnter={(e) => {
              !callStarted && isHovering !== 4 && setHover(4);
            }}
            onMouseOver={(e) => {
              !callStarted && isHovering !== 4 && setHover(4);
            }}
            onMouseLeave={(e) => {
              !callStarted && isHovering !== void 0 && setHover(void 0);
            }}
            className={`${classes.tabContainer} ${
              value === 4 || isHovering === 4 || value === 400
                ? classes.tabContainerSelected
                : ""
            } ${callStarted ? classes.disabledCursor : ""}`}
          >
            <div className={classes.iconWrapper}>
              <img
                className={`${classes.folderIcon} ${classes.searchIcon}`}
                src={callStarted ? disabledSearchIcon : searchIcon}
                alt=""
              />
            </div>
            <div className={classes.sideBarTextPrimary}>{Name.SEARCH_ORDERS}</div>
          </div>
        )}
        {...a11yProps(4)}
      />

      {
        VersionSelectorCollection.get(`${hasFeature.PATIENT_CHART_V1_VERSION_SELECTOR}`)
      }

      {SurveyLink && (
        <Tab
          component={(props) => (
            <div id="survey-tab" className={classes.tabContainerSurveyWrapper}>
              <a
                href={SurveyLink}
                target="_blank"
                rel="noopener noreferrer"
                id="survey-link-tab"
                style={{ textDecoration: "none", outline: "none" }}
                onClick={(e) => {
                  !callStarted && setHover(void 0);
                  !callStarted && setWidth(92);
                }}
                onMouseEnter={(e) => {
                  !callStarted && isHovering !== 3 && setHover(3);
                }}
                onMouseOver={(e) => {
                  !callStarted && isHovering !== 3 && setHover(3);
                }}
                onMouseLeave={(e) => {
                  !callStarted && isHovering !== void 0 && setHover(void 0);
                }}
                className={`${classes.tabContainer} ${
                  value === 3 || isHovering === 3
                    ? classes.tabContainerSelected
                    : ""
                } ${callStarted ? classes.disabledCursor : ""}`}
              >
                <img
                  className={`${classes.commentIconTransition} ${
                    tabWidth === 92
                      ? classes.commentIconCollapse
                      : classes.commentIconExpand
                  }`}
                  src={callStarted ? disabledCommentIcon : commentIcon}
                  alt=""
                />
                <div className={classes.sideBarTextSecondary}>
                  Participate in a survey here!
                </div>
              </a>
            </div>
          )}
          {...a11yProps(3)}
        />
      )}
    </Tabs>
  );

  return (
    <div
      data-view="verticalTab"
      data-app="verticalTab"
      className={classes.root}
    >
      {TabChildren}
      <TabPanel
        className={classes.tabPanelStyles}
        tabPannelClassName={classes.tabPannelClassName}
        value={value}
        index={0}
      >
        <ScheduledVisits
          {...restProps}
          cardData={cardData}
          openView={value === 100 ? "scheduleCards" : value}
          handleRouteChange={handleChange}
          hideRefresh
        />
      </TabPanel>
      <TabPanel
        className={classes.tabPanelStyles}
        tabPannelClassName={classes.tabPannelClassName}
        value={value}
        index={1}
      >
        <PendingFiles
          handleRouteChange={handleChange}
          openView={value === 200 ? "pendingFilesCard" : value}
          {...restProps}
          cardData={cardData}
          hideRefresh
        />
      </TabPanel>
      <TabPanel
        className={classes.tabPanelStyles}
        tabPannelClassName={classes.tabPannelClassName}
        value={value}
        index={2}
      >
        <div>tab 3</div>
      </TabPanel>
      <TabPanel
        className={classes.tabPanelStyles}
        tabPannelClassName={classes.tabPannelClassName}
        value={value}
        index={4}
      >
        <SearchOrders
          searchDataFields={searchDataFields}
          setSearchDataFields={setSearchDataFields}
          handleRouteChange={handleChange}
          openView={value === 400 ? "searchOrders" : value}
          {...restProps}
          cardData={cardData}
        />
      </TabPanel>
      <TabPanel
        className={classes.tabPanelStyles}
        tabPannelClassName={classes.tabPannelClassName}
        value={value}
        index={3}
      >
        <CommentView />
      </TabPanel>
    </div>
  );
}

export default withStyles(VerticalTabsStyle)(VerticalTabs);
